import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=3e0e0f69&scoped=true&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=3e0e0f69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e0f69",
  null
  
)

export default component.exports